export default "__VITE_ASSET__40f5e0fb__"